import { DeliveryMethod } from '../interfaces/orders.interface';

export const DELIVERY_METHOD: DeliveryMethod[] = [
  { id: 0, name: 'Self-delivery', price: 0 },
  { id: 1, name: 'Courier', price: 5 },
  { id: 2, name: 'In shop', price: 0 },
];

export enum OrderFiltersEnum {
  DATE_CREATED = 'dateCreated',
  DELIVERY_TYPE = 'deliveryTypes',
  STATUS = 'orderStatuses',
  CREATOR = 'creators',
}

export enum OrderDateCreatedEnum {
  Today = 'today',
  Yesterday = 'yesterday',
  Last7days = 'last7days',
  Last30days = 'last30days',
  ThisMonth = 'thisMonth',
  LastMonth = 'lastMonth',
  Custom = 'customRange',
}
